<ng-container [formGroup]="form">
  <ng-container formArrayName="sws">
    <div
      class="custom-control custom-switch mb-1"
      *ngFor="let switch of sws.controls; let i = index"
    >
      <input
        type="checkbox"
        class="custom-control-input"
        id="{{ class }}_{{ i }}"
        [formControlName]="i"
      />
      <label class="custom-control-label" for="{{ class }}_{{ i }}">{{
        class + '.switch.' + switches[i] | translate
      }}</label>
    </div>
  </ng-container>
</ng-container>
